import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'

import Question from "components/Question"

import { discectError, getSessionInfo } from "lib/utils"
import api from 'lib/api'

import styles from "./styles.module.scss"
import ButtonPrimary from "components/ButtonPrimary"

const OnBoardingInformation = ({ token, requirements, onGetToken, onRefresh }) => {
  const [currentSection, setCurrentSection] = useState(null)
  const [currentQuestion, setCurrentQuestion] = useState(null)
  const [isCompleted, setIsCompleted] = useState(null)
  const [hasFinishedSection, setHasFinishedSection] = useState(null)

  const navigate = useNavigate()

  const { sections } = requirements

  useEffect(() => {
    const _fetch = async () => {
      try {
        if (token) {
          const tokenResults = await onGetToken()
          if (tokenResults) {
            if (sections.length) {
              const nextQuestionData = await api.warehouse.fetchNextQuestion(token, tokenResults.token)
              if (nextQuestionData) {
                let { currentSection, currentQuestion, isCompleted } = nextQuestionData
                setCurrentSection(currentSection)
                setCurrentQuestion(currentQuestion)
                setIsCompleted(isCompleted)
              }
            } else {
              throw new Error('Required Sections are invalid')
            }
          } else {
            throw new Error('Token is invalid')
          }
        }
      } catch(e) {
        const error = discectError(e)
        if (['jwt expired','invalid signature','hash is invalid'].indexOf(error.toLowerCase()) >= 0) {
          await onGetToken(token, true)
          window.location.reload()
        }
      }
    }
    _fetch()
  }, [token, sections, onGetToken])

  const _doSave = async (questionId, data) => {

    let sessionInfoJson = getSessionInfo()

    const ACTIVE_SECTION = currentSection

    try {
      const { token: jwt } = await onGetToken(token)
      if (jwt) {
        const section = sections.find(itm => itm.id === currentSection)
        if (section) {
          const params = {
            caseId: null,
            sectionId: currentSection,
            text: data.text,
            payload: { ...data.data, sessionInfo: sessionInfoJson },
            notApplicable: data.notApplicable
          }
          const answer = await api.warehouse.answerQuestion(token, questionId, params, jwt)
          if (answer) {
            const nextQuestionData = await api.warehouse.fetchNextQuestion(token, jwt)
            if (nextQuestionData) {
              const { currentSection, currentQuestion, isCompleted } = nextQuestionData
              let hasFinishedSection = false
              if (ACTIVE_SECTION !== currentSection) hasFinishedSection = ACTIVE_SECTION
              setCurrentSection(currentSection)
              setCurrentQuestion(currentQuestion)
              setHasFinishedSection(hasFinishedSection)
              setIsCompleted(isCompleted)
            }
          }
          return Promise.resolve()
        }
      }
    } catch(e) {
      const error = discectError(e)
      console.error(error)
    }
  }

  const _onBackToOnboarding = async () => {
    await onRefresh(['INFORMATION'])
    navigate(`/onboarding`)
  }

  const _getContent = () => {
    if (hasFinishedSection) {
      const completedSection = sections.find(itm => itm.id === hasFinishedSection)
      if (completedSection) {
        return (
          <div className={styles.questionnaireContainer}>
            <p className="big">You have completed the {completedSection.name}. Let's keep going!</p>
            <div className={styles.calloutActions}>
              <button className="butt butt--teal" onClick={e => {
                setHasFinishedSection(false)
              }}>Continue</button>
            </div>
          </div>
        )
      }
    } else if (isCompleted) {
      return (
        <div className={styles.userDocuments__main}>
          <div className={styles.questionnaireContainer}>
            <p className="big">You have completed your information.</p>
            <div className={styles.paragraphCluster}>
              <p>If you would like to make any changes, please reach out to your Bail Bond Agent using the timeline on your profile page.</p>
              <p>If everything looks good, please proceed to the next section.</p>
            </div>
            <div className={styles.calloutActions}>
              <ButtonPrimary color="navy" onClick={_onBackToOnboarding}>Back to Onboarding</ButtonPrimary>
            </div>
          </div>
        </div>
      )
    }
    const section = sections.find(itm => itm.id === currentSection)
    if (section) {
      if (section.questions && section.questions.length) {
        return (
          <div className={styles.userDocuments__main}>
            <Question 
              section={section}
              currentQuestionId={currentQuestion}
              onDeveloperBypass={null}
              // onFinish={this._onFinish}
              onSave={_doSave}
              onBack={null}
            />
          </div>
        )
      } else {
        return <p>Question do not exist for {section.name}.</p>
      }
    }
  }

  return (
    <div className={styles.container}>
      {_getContent()}
    </div>
  )
}

export default OnBoardingInformation
